import React, { ChangeEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Button,
  CardMedia,
  Checkbox,
  FormControlLabel,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";

import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const usersList = [
  { label: "Select All Users", id: "all" },
  { label: "John Doe", id: "1" },
  { label: "Jane Smith", id: "2" },
  { label: "Michael Scott", id: "3" },
  { label: "Pam Beesly", id: "4" },
];

const AddPromotion = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [autoCompleteOpen, setAutoCompleteOpen] = React.useState(true);
  const [selectedUsers, setSelectedUsers] = React.useState<typeof usersList>(
    []
  );
  const [type, setType] = React.useState("default");
  const [template, seTemplate] = React.useState("default");

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const isAddPromotion = location.pathname === "/manage-promotions/add";
  const handleUsersChange = (event: any, value: typeof usersList) => {
    const isSelectAllClicked = value.some((user) => user.id === "all");

    if (isSelectAllClicked) {
      const isAllSelected = selectedUsers.length === usersList.length - 1;

      if (isAllSelected) {
        // Uncheck all
        setSelectedUsers([]);
      } else {
        // Select all (excluding "Select All" option itself)
        const allUsers = usersList.filter((user) => user.id !== "all");
        setSelectedUsers(allUsers);
      }
    } else {
      setSelectedUsers(value);
    }
  };

  return (
    <>
      <div className="main_title">
        <h1>{isAddPromotion ? "Add " : "Edit "} Promotion</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-promotions")}>
            Promotion Management
          </button>{" "}
          - {isAddPromotion ? "Add " : "Edit "} Promotion
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <div className="gap_p">
                <div className="control_group w_33">
                  <label htmlFor="icon-button-file">Upload Image</label>
                  {image ? (
                    <div className="upload_image v2 no_radius">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia
                            component="img"
                            image={image}
                            alt="Uploaded profile photo"
                          />
                        </figure>
                        <IconButton
                          aria-label="Remove uploaded image"
                          onClick={() => {
                            setImage("");
                            setFileName("");
                          }}
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    <label
                      className="upload_image v2 no_radius"
                      htmlFor="icon-button-file"
                    >
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{ accept: "image/png,image/jpeg" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = (event.target as HTMLInputElement)
                            .files;
                          if (files && files[0].type.includes("image")) {
                            setFileName(files[0].name);
                            setImage(URL.createObjectURL(files[0]));
                          } else {
                            setAlertType(0);
                            setShowAlert(true);
                            setAlertMessage("This field only accepts images.");
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt="placeholder"
                          />
                          <span className="upload_img_icon">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Upload"
                            />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
              </div>
            </div>

            <div className="control_group w_33">
              <label htmlFor="Title">Title</label>
              <TextField
                id="Title"
                placeholder="Enter Title"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="Type">Promotion Type</label>
              <Select
                id="Type"
                fullWidth
                value={Status}
                onChange={handleStatusChange}
              >
                <MenuItem disabled value="default">
                  Select Type
                </MenuItem>
                <MenuItem value="App">App only</MenuItem>
                <MenuItem value="store">In-store</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="URL">
                URL <span> (for external articles)</span>{" "}
              </label>
              <TextField
                id="URL"
                placeholder="Enter URL"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_100">
              <label htmlFor="noti_datetime">Schedule Promotion</label>
              <div className="gap_p">
                <div className="control_group w_50">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                      }}
                      slotProps={{
                        textField: {
                          id: "noti_datetime",
                          placeholder: "Select Start Date & Time",
                          fullWidth: true,
                          hiddenLabel: true,
                        },
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>
                <div className="control_group w_50">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                      }}
                      slotProps={{
                        textField: {
                          id: "noti_datetime",
                          placeholder: "Select End Date & Time",
                          fullWidth: true,
                          hiddenLabel: true,
                        },
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
            <div className="control_group">
              <label htmlFor="dob">Target Audience</label>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={usersList}
                value={selectedUsers}
                onChange={handleUsersChange}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onOpen={() => setAutoCompleteOpen(true)}
                onClose={() => setAutoCompleteOpen(false)}
                renderOption={(props, option, { selected }) => {
                  const isAllOption = option.id === "all";
                  const isAllSelected =
                    selectedUsers.length === usersList.length - 1; // exclude "Select All"

                  return (
                    <li {...props}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isAllOption ? isAllSelected : selected}
                            indeterminate={
                              isAllOption &&
                              selectedUsers.length > 0 &&
                              !isAllSelected
                            }
                          />
                        }
                        name="option"
                        label={option.label}
                      />
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Users"
                    variant="outlined"
                  />
                )}
              />
            </div>

            <div className="control_group ">
              <label htmlFor="Description">Description</label>
              <TextField
                id="Description"
                minRows={5}
                multiline
                placeholder="Enter Description"
                hiddenLabel
                fullWidth
              />
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPromotion;
